const registration = {
  registration: {
    backButton: 'Powrót do logowania',
    pageHeader: 'Rejestracja nowego użytkownika',
    installerNote:
      'Skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył identyfikator użytkownika i wysłał Ci zaproszenie',
    registerOption: 'Chcę zarejestrować nową firmę fotowoltaiczną w Enphase',
    installerOption: 'Jestem instalatorem pracującym dla firmy, która już instalowała systemy Enphase',
    doItYourselfOption: 'Jestem instalatorem montującym produkty Enphase',
    homeownerOption: 'Jestem właścicielem domu',
    updateSignuppage: 'Zgadzam się, aby firma Enphase kontaktowała się ze mną za pośrednictwem połączeń telefonicznych i wiadomości tekstowych na podany powyżej numer telefonu w celu uzyskania informacji o systemie, aktualizacji lub wiadomości marketingowych związanych z moim systemem. Te połączenia i SMS-y marketingowe mogą być wybierane automatycznie lub generowane przez sztuczny lub nagrany wcześniej głos. Moja zgoda na te wiadomości nie jest warunkiem zakupu i może zostać odwołana w dowolnym momencie i w dowolny rozsądny sposób.',
    termsAndServices:
      'Potwierdzam przeczytanie %{privacyPolicy} firmy Enphase, a także przeczytanie i akceptację %{termsService}',
    termsServicesSafetyDisclaimer:
      'Potwierdzam przeczytanie i zaakceptowanie %{safetyDisclaimer}, %{privacyPolicy} oraz %{termsService} firmy Enphase',
    safetyDisclaimer: 'Zastrzeżenie dotyczące bezpieczeństwa',
    accountHeader: 'Szczegóły Twojego konta',
    companyDetails: 'Dane firmy',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    country: 'Kraj',
    email: 'E-mail',
    verificationHeader: 'Wprowadź kod weryfikacyjny',
    verificationNote: 'Wprowadź sześciocyfrowy kod weryfikacyjny, który wysłano na adres %{email}',
    didntReceivedOtp: 'Nie otrzymano kodu weryfikacyjnego?',
    resendOtp: 'Wyślij kod weryfikacyjny ponownie',
    setPasswordHeader: 'Ustaw hasło do aplikacji Enlighten',
    setPasswordNote: 'Musi mieć od 6 do 50 znaków i zawierać co najmniej 1 cyfrę lub znak specjalny.',
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    safetyDisclaimerNote:
      'Prace montażowe, serwisowe i konserwacyjne produktów firmy Enphase powinny być wykonywane wyłącznie przez wykwalifikowany personel. Prace elektryczne muszą być wykonywane przez licencjonowanych elektryków przeszkolonych w zakresie przepisów elektrycznych obowiązujących w danym regionie lub kraju oraz posiadających wiedzę na temat wymagań prawnych i względów bezpieczeństwa związanych z instalacjami solarnymi oraz magazynowaniem energii słonecznej i zarządzaniem nią. Zawsze odwołuj się do instrukcji instalacji i przewodników.',
    fieldRequired: 'To pole jest wymagane.',
    validEmail: 'Wprowadź prawidłowy adres e-mail.',
    validPhone: 'Wprowadź prawidłowy numer telefonu.',
    companyName: 'Nazwa firmy',
    streetAddress: 'Ulica i numer',
    streetAddress2: 'Ulica i numer 2',
    city: 'Miejscowość',
    state: 'Województwo',
    zip: 'Kod pocztowy',
    supportEmail: 'Adres e-mail obsługi klienta',
    supportPhone: 'Numer telefonu obsługi klienta',
    wesbiteUrl: 'Adres URL witryny',
    companyLogo: 'Logo firmy',
    chooseFile: 'Wybierz plik',
    noFile: 'Nie wybrano żadnego pliku',
    chooseFileNote: 'Musi to być plik JPEG, GIF lub PNG nie większy niż 4 MB.',
    enphaseInstaller: 'Ta firma instaluje lub planuje zainstalować systemy Enphase',
    privacyPolicy: 'Zasad ochrony prywatności',
    termsService: 'Warunków świadczenia usługi',
    andText: 'oraz',
    accountNote:
      'Uwaga! Systemy dodane w ramach tego konta nie zostaną przypisane do żadnego instalatora w celu konserwacji',
    phone: 'Tel.',
    passwordMismatch: 'Hasła wprowadzone w powyższych polach powinny być zgodne',
    updateSignupError: 'Zaznacz powyższe pole wyboru, aby kontynuować rejestrację',
    privaryPolicyError:
      'Jeśli nie zgadzasz się z warunkami Polityki prywatności Enphase i Warunkami świadczenia usług, nie możesz zarejestrować się w Enlighten.',
    otpSuccess: 'Kod weryfikacyjny został pomyślnie wysłany ponownie',
    registrationSuccess: 'Twoje konto Enlighten zostało pomyślnie utworzone',
    registrationSuccessRedirection: 'Pomyślnie zarejestrowano Cię w aplikacji Enlighten. Logowanie…',
    login: 'Zaloguj',
    warningName:
      'Ostrzeżenie! Firma o tej nazwie już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    errorName:
      'Firma o tej nazwie już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    warningAddress:
      'Ten adres jest powiązany z firmą, która już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    errorSupportEmail:
      'Ten identyfikator e-mail jest powiązany z firmą, która już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    errorSupportPhone:
      'Ten numer telefonu jest powiązany z firmą, która już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    warningUrl:
      'Ten link do witryny internetowej jest powiązany z firmą, która już istnieje w systemie. Aby zapewnić sobie właściwy dostęp, skontaktuj się z administratorem swojej firmy / swojego oddziału, aby utworzył Twój identyfikator, lub skontaktuj się z pomocą techniczną Enphase.',
    errorPhone:
      'Ten numer telefonu jest już powiązany z istniejącym kontem. Użyj innego numeru kontaktowego lub skontaktuj się z pomocą techniczną Enphase.',
    errorEmail:
      'Ten adres e-mail jest już powiązany z istniejącym kontem. Użyj innego adresu e-mail lub skontaktuj się z pomocą techniczną Enphase.',
    streetNumberEmptyError: 'Nie znaleziono numeru domu, zweryfikuj przed zapisaniem.',
    recaptchaError: 'Aby kontynuować, przeprowadź weryfikację reCAPTCHA.',
    infoText: 'Upewnij się, że znacznik jest umieszczony w dokładnej lokalizacji.',
    warningText: 'Upewnij się, że umieszczasz znacznik w dokładnej lokalizacji.',
    locateMeText: 'Użyj przycisku Zlokalizuj mnie, aby uzyskać swoją aktualną lokalizację.',
    addressCheckText: 'Upewnij się, że wpisujesz poprawny adres',
    markerText: 'Umieść znacznik w dokładnej lokalizacji',
    mapErrorText: 'Przykro nam! Nie byliśmy w stanie zlokalizować Cię w Mapach Google.',
    validChamberNumber: 'Nieprawidłowe dane wejściowe! Minimum 8 znaków wymaganych dla numeru Izby Handlowej',
    chamberofcommerce: 'Numer Izby Handlowej',
  }
};

export default registration;
